import { DocPage, Section, SpecTable } from "../../components/DocChrome";

export function StatesPage() {
    return (
        <DocPage
            title="Component States"
            description="Shared interaction model. Only apply states that make sense for the control."
        >
            <Section title="Universal states">
                <SpecTable
                    rows={[
                        ["default", "Resting appearance"],
                        ["hover", "Pointer devices only"],
                        ["focus-visible", "Keyboard focus ring (2px primary)"],
                        ["active / pressed", "Momentary press feedback"],
                        ["selected / checked", "Toggle and list selection"],
                        ["disabled", "opacity ~40%, no pointer, not focusable for submit"],
                        ["read-only", "Focusable but not editable"],
                        ["loading", "Replace label with spinner; keep width stable"],
                        ["error / invalid", "Danger border + describedby error"],
                        ["empty", "Placeholder / empty pattern"],
                    ]}
                />
            </Section>
            <Section title="Rules">
                <ul className="list-disc space-y-1 ps-5">
                    <li>Never remove focus rings without an equivalent visible focus style.</li>
                    <li>Disabled controls must not rely on color alone — use opacity + cursor.</li>
                    <li>Loading buttons stay disabled until the request settles.</li>
                </ul>
            </Section>
        </DocPage>
    );
}
